export function formatSessionDate(value, timeZone) {
    if (value === null || value === undefined || value === '') return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';
    return new Intl.DateTimeFormat('ru-RU', {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hourCycle: 'h23',
        ...(timeZone ? { timeZone } : {})
    }).format(date);
}

// A duration is not a calendar date: it has no timezone or 24-hour rollover.
export function formatElapsedTime(milliseconds) {
    const seconds = Number.isFinite(milliseconds) ? Math.max(0, Math.floor(milliseconds / 1000)) : 0;
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return [hours, minutes, seconds % 60].map(value => String(value).padStart(2, '0')).join(':');
}
